import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectFloorFilter } from 'shared/selectors/advancedFilters';
import { IsNotFirstFloorContainer, IsNotLastFloorContainer, OnlyLastFloorContainer } from './containers';
import { FC } from 'react';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';

export const FloorContainer: FC = () => {
  const {
    label,
    value: { min: valueMin, max: valueMax },
    min,
    max,
  } = useSelector(selectFloorFilter);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setFloorMin', arguments: [value] });
  });

  const handleMaxChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setFloorMax', arguments: [value] });
  });

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        <InlineFilter width={100}>
          <RangeInput
            min={min}
            max={max}
            valueMin={valueMin}
            valueMax={valueMax}
            onChangeMin={handleMinChange}
            onChangeMax={handleMaxChange}
          />
        </InlineFilter>

        <IsNotFirstFloorContainer />

        <IsNotLastFloorContainer />

        <OnlyLastFloorContainer />
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
